export default function Success() {
  return (
    <div>
      <h1>🎉 Payment Successful!</h1>
      <p>Thank you for subscribing. You can now access premium features.</p>
      <a href="/dashboard">Go to Dashboard</a>
    </div>
  );
}
